export enum SystemStatus {
  AVAILABLE = 'AVAILABLE',
  DOWN = 'DOWN',
  MAINTENANCE = 'MAINTENANCE',
  HIGH_LOAD = 'HIGH_LOAD'
}

export interface SystemStatusConfiguration {
  readonly systemStatus: SystemStatus;
  readonly firstStartAfterLogin: boolean;
  readonly systemDownErrorCode?: string;
  readonly systemWarningErrorCode?: string;
}
